import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProcedimientosService } from 'src/app/_services/procedimientos.service';
import { ClientLoaderService } from 'src/app/core/util/client-loader.service';

@Component({
  selector: 'app-footer-emvs',
  templateUrl: './footer-emvs.component.html',
  styleUrls: ['./footer-emvs.component.css']
})
export class FooterEmvsComponent extends UnsubscribeOnDestroy implements OnInit {

  date: number = 0;
  logoFooterUrl = '';
  footerWebUrl = '';
  footerContactUrl = '';
  footerTermsUrl = '';
  footerCertUrl = '';
  footerCertImage = '';
  showSocial = false;
  socialTwitter = '';
  socialInstagram = '';
  socialYoutube = '';
  socialLinkedin = '';
  socialRss = '';

  constructor(
    private router: Router,
    private _serviceProcedimientos: ProcedimientosService,
    public clientLoader: ClientLoaderService,
  ) {
    super();
  }

  ngOnInit() {
    this.date = new Date().getFullYear();
    this.logoFooterUrl = this.clientLoader.getClientImage('footer');
    this.footerWebUrl = this.clientLoader.getConfigSync('footer_web_url');
    this.footerContactUrl = this.clientLoader.getConfigSync('footer_contact_url');
    this.footerTermsUrl = this.clientLoader.getConfigSync('footer_terms_url');
    this.footerCertUrl = this.clientLoader.getAssetUrl(
      this.clientLoader.getConfigSync('footer_cert_url')
    );
    this.footerCertImage = this.clientLoader.getAssetUrl(
      this.clientLoader.getConfigSync('footer_cert_image')
    );
    this.showSocial = this.clientLoader.isFeatureEnabled('feature_footer_social');
    this.socialTwitter = this.clientLoader.getConfigSync('footer_social_twitter');
    this.socialInstagram = this.clientLoader.getConfigSync('footer_social_instagram');
    this.socialYoutube = this.clientLoader.getConfigSync('footer_social_youtube');
    this.socialLinkedin = this.clientLoader.getConfigSync('footer_social_linkedin');
    this.socialRss = this.clientLoader.getConfigSync('footer_social_rss');
  }

  recuperaUrlConcacto(): string {
    const defaultContact = this.footerContactUrl || '#';
    if (this.router.url.includes('RPSV')) {
      this.getProcedimiento(2);
    } else if (this.router.url.includes('instancia-general')) {
      this.getProcedimiento(1);
    } else if (this.router.url.includes('anexo3_participacion_concurso')) {
      this.getProcedimiento(3);
    } else if (this.router.url.includes('formulario')) {
      const lastUrlSegment = this.router.url.split('?')[0].split('/').pop();
      this.getProcedimientoCustom(lastUrlSegment);
    } else {
      this.navegaSeccion(defaultContact);
    }
    return defaultContact;
  }

  private getProcedimiento(id: any): void {
    this._serviceProcedimientos
      .getProcedimiento(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          const proc = procedimiento['Procedimiento'];
          const base = this.footerContactUrl || 'https://www.emvs.es/Contactar';
          const url = base.includes('?')
            ? `${base}&topic=oficinaVirtual&proc=${encodeURIComponent(proc.nombre)}`
            : `${base}?topic=oficinaVirtual&proc=${encodeURIComponent(proc.nombre)}`;
          this.navegaSeccion(url);
        },
        error: () => {},
      });
  }

  private getProcedimientoCustom(id: any): void {
    this._serviceProcedimientos
      .getProcedimiento(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          const proc = procedimiento['Procedimiento'];
          const base = this.footerContactUrl || 'https://www.emvs.es/consulta-general';
          const url = `${base}?topic=oficinaVirtual&proc=${encodeURIComponent(proc.nombre)}`;
          this.navegaSeccion(url);
        },
        error: () => {},
      });
  }

  navegaSeccion(ruta: string) {
    if (ruta && ruta !== '#') {
      window.open(ruta, '_blank');
    }
  }
}
